import { useMemo } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { MONTH_LABELS, formatWon } from "Components/Sales/salesFormat";

const COLORS = {
  gross: "#2563eb",
  net: "#059669",
  compareGross: "#9ca3af",
  compareNet: "#6ee7b7",
};

const formatTick = (value) => `${(value / 10000).toLocaleString("ko-KR")}만`;

const buildRows = (months, compare) => {
  const byMonth = new Map((months || []).map((m) => [m.month, m]));
  const cmpByMonth = new Map((compare?.months || []).map((m) => [m.month, m]));
  return MONTH_LABELS.map((label, i) => {
    const m = byMonth.get(i + 1);
    const c = cmpByMonth.get(i + 1);
    return {
      label,
      gross: m ? m.gross : null,
      net: m ? m.net : null,
      compareGross: c ? c.gross : null,
      compareNet: c ? c.net : null,
    };
  });
};

const TrendLineChart = ({ year, months, compare, metric }) => {
  const rows = useMemo(() => buildRows(months, compare), [months, compare]);

  const showGross = metric !== "net";
  const showNet = metric !== "gross";

  return (
    <ResponsiveContainer width="100%" height={340}>
      <LineChart data={rows} margin={{ top: 16, right: 24, bottom: 8, left: 8 }}>
        <CartesianGrid stroke="#e5e7eb" vertical={false} />
        <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
        <YAxis tickFormatter={formatTick} tick={{ fontSize: 11, fill: "#6b7280" }} axisLine={false} tickLine={false} width={64} />
        <Tooltip formatter={(value) => formatWon(value)} labelStyle={{ fontWeight: 600 }} />
        <Legend wrapperStyle={{ fontSize: 13 }} />
        {showGross && (
          <Line type="linear" dataKey="gross" name={`${year} 매출`} stroke={COLORS.gross} strokeWidth={2} dot={false} activeDot={{ r: 5 }} connectNulls={false} />
        )}
        {showNet && (
          <Line type="linear" dataKey="net" name={`${year} 순매출`} stroke={COLORS.net} strokeWidth={2} dot={false} activeDot={{ r: 5 }} connectNulls={false} />
        )}
        {compare && showGross && (
          <Line type="linear" dataKey="compareGross" name={`${compare.year} 매출`} stroke={COLORS.compareGross} strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{ r: 4 }} />
        )}
        {compare && showNet && (
          <Line type="linear" dataKey="compareNet" name={`${compare.year} 순매출`} stroke={COLORS.compareNet} strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{ r: 4 }} />
        )}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TrendLineChart;
